export const PIPELINE_STATUS_ENUM = {
  CREATED: 'CREATED',
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  CANCELED: 'CANCELED',
  SKIPPED: 'SKIPPED',
  MANUAL: 'MANUAL',
  SCHEDULED: 'SCHEDULED',
  PREPARING: 'PREPARING',
  WAITING_FOR_RESOURCE: 'WAITING_FOR_RESOURCE',
  WARNING: 'WARNING'
};


export const CICD_TEST_STATUS_ENUM = {
  PASSED: {status: "PASSED", id: "passedNumber", text: "Завершен успешно"},
  SKIPPED: {status: "SKIPPED", id: "skippedNumber", text: "Пропущен"},
  ERROR: {status: "ERROR", id: "errorsNumber", text: "Завершен с ошибкой"},
  FAILED: {status: "FAILED", id: "failuresNumber", text: "Не завершен"},
  EMPTY: {status: "EMPTY", id: "", value: "empty", name: "Нет данных" }
}
